/**
 * Obtiene la fecha actual del sistema formateada como `AAAA-MM-DD`.
 * @returns La fecha actual en formato `AAAA-MM-DD`.
 */
export function getDate(): string {
  const currentDate = new Date();
  const year = currentDate.getFullYear();
  const month = String(currentDate.getMonth() + 1).padStart(2, '0');
  const day = String(currentDate.getDate()).padStart(2, '0');
  const date = `${year}-${month}-${day}`;
  return date;
}
